let calculator = document.getElementById('calculator');
let dateCookie = new Date(new Date().getTime() + 2592000000);

const submitCalc = document.getElementById('calc_submit');
const selectError = document.getElementById('selectError');
const loanPurpose = document.getElementById('loanPurpose');


if (submitCalc) {
    var submitHref = submitCalc.href;
    const getParams = window.location.search;

    if (getParams) {
        submitCalc.href = submitHref + getParams;
    } else {
        submitCalc.href = submitHref;
    }

    if (loanPurpose) {
        submitCalc.addEventListener('click', function (e) {
            if (loanPurpose.value == 'error') {
                e.preventDefault();

                if (selectError) {
                    selectError.classList.add('select-error_active');
                }
            }
        });
    }
}

if (calculator) {
    submitHref = submitCalc.href;

    load_price();

    if (loanPurpose) {
        load_purposes();

        loanPurpose.addEventListener('change', () => {
            selectError.classList.remove('select-error_active');
            document.cookie = "loan_purpose=" + loanPurpose.value + "; path=/; expires=" + dateCookie.toUTCString() + "; secure; SameSite=Strict";
        });
    }
}

async function load_price() {
    const productID = typeof calcProductID !== 'undefined' ? +calcProductID : 4;

    let get_price = await fetch('https://' + api_url + '/api/products/' + productID + '/price_list', {
        method: 'GET'
    });

    switch (get_price.status) {
        case 200:
            let loan_price = await get_price.json();
            initRange(loan_price);
            break;
        default:
            console.log('Error api: ' + api_url + '; status: ' + get_price.status);
    }
}

async function load_purposes() {
    let get_purposes = await fetch('https://' + api_url + '/api/dictionary/loan_purpose', {
        method: 'GET'
    });

    switch (get_purposes.status) {
        case 200:
            let purposes = await get_purposes.json();
            purposes.forEach(e => {
                if (e.is_enabled == true) {
                    let data_type = '';
                    if (e.name == 'other') {
                        data_type = ' data-type="other"';
                    }
                    loanPurpose.innerHTML += `<option value="${e.id}"${data_type}>${e.name}</option>`;
                }
                loanPurpose.removeAttribute('disabled');
            });
            break;
        default:
            console.log('Error api: ' + api_url + '; status: ' + get_price.status);
    }
}

function initRange(loan_price) {
    const input = document.getElementById('amount_text');
    const range = document.getElementById('amount_range');
    const minus = document.getElementById('amount_minus');
    const plus = document.getElementById('amount_plus');
    const value_min = document.getElementById('amount_min');
    const value_max = document.getElementById('amount_max');
    const defaultAmount = typeof calcDefaultSum !== 'undefined' ? +calcDefaultSum : 3000;
    const amountLimit = typeof calcAmountLimit !== 'undefined' ? +calcAmountLimit : 2500;
    const currency = input.getAttribute('data-currency');
    const defaultAmountList = document.querySelectorAll('[data-amount-default]');
    const isDefaultAmountList = defaultAmountList && defaultAmountList.length > 0;

    // IND-2293
    const showNotice = (value) => {
        const percentage = (100 * (value - range.min)) / (range.max - range.min);

        if (value > amountLimit) {
            document.querySelector('.calculator-elem__slide').classList.add('calculator-elem__slide_warning')
            document.querySelector('.calculator-elem__slide').classList.remove('calculator-elem__slide_success')
            document.querySelector('.calculator-elem__notice').style.display = 'flex'
            range.style.background = `linear-gradient(90deg, #fabb02 ${percentage}%, #BFD1EB ${percentage}%)`;
        } else {
            document.querySelector('.calculator-elem__slide').classList.add('calculator-elem__slide_success')
            document.querySelector('.calculator-elem__slide').classList.remove('calculator-elem__slide_warning')
            document.querySelector('.calculator-elem__notice').style.display = 'none'
            range.style.background = `linear-gradient(90deg, #2A9638 ${percentage}%, #BFD1EB ${percentage}%)`;
        }
    }

    // IND-2324
    const setDefaultAmount = (value) => {
        const percentage = (100 * (value - range.min)) / (range.max - range.min);
        range.style.background = `linear-gradient(90deg, #225AAC ${percentage}%, #BFD1EB ${percentage}%)`;

        defaultAmountList.forEach(item => {
            if (value == item.value) item.checked = true
        })
    }

    let array_term = Object.keys(loan_price);
    let array_amount = Object.keys(loan_price[array_term[0]]);

    let cookie_amount = getCookie('loan_sum');
    let amount_value = (cookie_amount && !isDefaultAmountList) ? +cookie_amount : defaultAmount;

    value_min.textContent = currency + (new Intl.NumberFormat('en-IN').format(array_amount[0]));
    value_max.textContent = currency + (new Intl.NumberFormat('en-IN').format(array_amount[array_amount.length - 1]));
    range.setAttribute('min', array_amount[0]);
    range.setAttribute('max', array_amount[array_amount.length - 1]);
    range.setAttribute('step', array_amount[1] - array_amount[0]);
    range.setAttribute('value', amount_value);

    // IND-2324
    if (isDefaultAmountList) {
        const amountArr = [];
        defaultAmountList.forEach(item => {
            amountArr.push(item.value.replace(/[^0-9^\,]/, ''))

            item.addEventListener('change', (e) => {
                const input_value = e.target.value.replace(/[^0-9^\,]/, '');
                setValue(+input_value, input, range, loan_price);
            })
        })

        value_max.textContent = currency + (new Intl.NumberFormat('en-IN').format(amountArr[amountArr.length - 1]));
        range.setAttribute('max', amountArr[amountArr.length - 1]);
    }

    setValue(amount_value, input, range, loan_price);
    isDefaultAmountList ? setDefaultAmount(amount_value) : showNotice(amount_value);

    if (minus) {
        minus.addEventListener('click', () => {
            setValue(+range.value - range.step, input, range, loan_price);
            isDefaultAmountList ? setDefaultAmount(+range.value) : showNotice(+range.value);
        })
    }

    if (plus) {
        plus.addEventListener('click', () => {
            setValue(+range.value + +range.step, input, range, loan_price);
            isDefaultAmountList ? setDefaultAmount(+range.value) : showNotice(+range.value);
        })
    }

    range.addEventListener('input', () => {
        setValue(+range.value, input, range, loan_price);
        isDefaultAmountList ? setDefaultAmount(+range.value) : showNotice(+range.value);
    });

    /*
    input.addEventListener('input', () => {
        input.value = input.value.replace(/[^0-9^\,]/, '');
        isDefaultAmountList ? setDefaultAmount(amount_value) : showNotice(amount_value);
    });
    */

    input.addEventListener('change', () => {
        let input_value = input.value.replace(/\,/g, '');

        if (input_value == null) {
            input_value = range.min;
        }

        setValue(+input_value, input, range, loan_price);

        isDefaultAmountList ? setDefaultAmount(range.value) : showNotice(range.value);
    });

    range.addEventListener('mousedown', () => {
        range.classList.add('calculator__input-range--active')
    });
    range.addEventListener('touchstart', () => {
        range.classList.add('calculator__input-range--active')
    });

    range.addEventListener('mouseup', () => {
        range.classList.remove('calculator__input-range--active')
    });
    range.addEventListener('touchend', () => {
        range.classList.remove('calculator__input-range--active')
    });

    document.querySelector('.calculator__loader').style.display = 'none';
}

function setValue(value, input, range, loan_price) {
    const settlementAmount = document.getElementById('settlement_amount');
    const summa_discount = document.getElementById('summa_discount');
    const wrap_discount = document.getElementById('wrap_discount');
    const maturityDate = document.getElementById('maturityDate');
    const maturityDay = document.getElementById('maturityDay');
    const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const month = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    const loanTerm = typeof calcLoanTerm !== 'undefined' ? +calcLoanTerm : 15;

    value = value < range.min ? range.min : value > range.max ? range.max : value;

    range.value = value;
    value = range.value;
    input.value = new Intl.NumberFormat('en-IN').format(value);

    const percentage = (100 * (value - range.min)) / (range.max - range.min);
    range.style.background = `linear-gradient(90deg, #225AAC ${percentage}%, #BFD1EB ${percentage}%)`;

    // Date
    let newDate = new Date(loan_price[loanTerm][value].maturity_date);
    let day = weekday[newDate.getDay()];

    let date = newDate.getDate() + ' ' + month[newDate.getMonth()] + ' ' + newDate.getFullYear();

    if (!calculator.classList.contains('none-result')) {

        if (loan_price[loanTerm][value].discount.settlement_amount && !loan) {

            settlementAmount.textContent = new Intl.NumberFormat('en-IN').format(loan_price[loanTerm][value].settlement_amount - loan_price[loanTerm][value].discount.settlement_amount);

            //Discount
            summa_discount.textContent = new Intl.NumberFormat('en-IN').format(loan_price[loanTerm][value].settlement_amount + loan_price[loanTerm][value].discount.settlement_amount);

            maturityDate.textContent = date;
            maturityDay.textContent = day;

            wrap_discount.style.display = 'block';

        } else {
            settlementAmount.textContent = new Intl.NumberFormat('en-IN').format(loan_price[loanTerm][value].settlement_amount);
            maturityDate.textContent = date;
            maturityDay.textContent = day;

            wrap_discount.style.display = 'none';
        }

    }

    document.cookie = "loan_sum=" + value + "; path=/; expires=" + dateCookie.toUTCString() + "; secure; SameSite=Strict";
    document.cookie = "loan_term=" + loanTerm + "; path=/; expires=" + dateCookie.toUTCString() + "; secure; SameSite=Strict";
}

function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}
